export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.652 11.782A4.124 4.124 0 013.53 7.657 4.124 4.124 0 017.652 3.53a4.124 4.124 0 014.121 4.126 4.124 4.124 0 01-4.121 4.125zm7.848 2.989l-3.871-3.874c.723-.888 1.175-2.006 1.175-3.24A5.155 5.155 0 007.652 2.5 5.154 5.154 0 002.5 7.657a5.154 5.154 0 005.152 5.156c1.24 0 2.361-.456 3.25-1.186l3.87 3.873.728-.73z\" fill=\"currentColor\"/>",
  "attrs": {
    "width": "18",
    "height": "18",
    "viewBox": "0 0 18 18",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};